export default {"theme":{"themes":{"light":{"primary":"#0073E6","secondary":"#E0F0FF","accent":"#82B1FF","error":"#FF5252","info":"#2196F3","success":"#4CAF50","warning":"#FFC107"}}}}
